<template>
    <div class="iframe-box">
        <loading v-show="lab_url.length == 0" :percent="percent" :txt="progressTxt"></loading>
        <iframe v-show="lab_url"
                class="iframe"
                :src="lab_url"
                style="width: 100%;height: 100%;padding-left: 5px"
                ref="terminals"
        ></iframe>
        <ToolBar :endTime="end_time" :expiredIn="expiredIn" :labId="lab_id"  :labIdKey="'lab_id'" :domainName="domain_name" :appraisalinfo="appraisalinfo"/>
        <Modal
                v-model="envModal"
                title="实训结束提示"
                @on-ok="ok">
            <p style="font-size: 16px">实训已经结束！实训环境容器已删除!</p>
        </Modal>
        <Modal
                v-model="errorModal"
                title="实训环境加载错误"
                @on-ok="errorOk"
                ok-text="重新启动"
        >
            <p style="font-size: 16px">实训环境加载错误!错误代码<span style="color: red">{{errorMsg}}</span></p>
        </Modal>
    </div>
</template>

<script>
    import Loading from './common/loading'
    import common from './common/agent_mixins'
    import ToolBar from './tool_bar'
    import {mapState} from "vuex";
    export default {
        data: function () {
            return {
                // lab_id:'',
                lab_query:{},
                envModal:false,
                // lab_url:'',
            }
        },
        props: {
            currentImgType: String,
            domain_name:String,
            appraisalinfo:Object
        },
        mixins: [common],
        components: {
            Loading,
            ToolBar
        },
        computed: {
            ...mapState({
                cur_subsection_info: state => state.courseManage.cur_subsection_info,
            }),
        },
        methods: {
            ok(){

            }
        },
        created() {
            this.heartbeatInterval(this.lab_id);
            this.$watch('cur_subsection_info',(val)=>{
                let _this = this;
                console.log("watch-lab_id:"+_this.lab_id);
                if (_this.lab_id == null || _this.lab_id == undefined || _this.lab_id == '') {
                    _this.getLabApply(val.id)
                } else {
                    _this.getLabQuery(val.id)
                }
            },{immediate:true})
        },
        mounted(){

            

        },
        watch: {
            lab_id:function(val){
                this.heartbeatInterval(val)
            },
            // 'cur_subsection_info.id':{
            //     handler(val)
            //     {
            //         let _this = this;
            //         if (_this.lab_id == null || _this.lab_id == undefined || _this.lab_id == '') {
            //             console.log(111122223333);
            //             console.log(this.domain_name);
            //             _this.getLabApply(val)
            //         } else {
            //             _this.getLabQuery(val)
            //         }
            //     },
            //     immediate:true
            // },
        }
    }
</script>

<style scoped >
    .iframe-box{
        height: 100%;
        width: 100%;
    }
    .iframe{
        width:0px;
        height:0px;
        margin:auto
    }
</style>
